export interface Teacher {
    id: number;
    firstName: string;
    lastName: string;
    login: string;
    role: TeacherRole;
    enabled: boolean;
}

export enum TeacherRole {
    ADMIN = 'ADMIN',
    USER = 'USER'
}

export const TeacherRoleNameMap = {
    [TeacherRole.ADMIN]: 'Админ',
    [TeacherRole.USER]: 'Учитель'
}


export interface TeacherCreateRequest {
    firstName: string;
    lastName: string;
    login: string;
    password: string;
    role: TeacherRole;
}

export interface TeacherUpdateRequest {
    firstName?: string | null;
    lastName?: string | null;
    password?: string | null;
    role?: TeacherRole | null
}